import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import API_ROUTES from '../../api';
import axios from 'axios';
import {
    Card, Grid, NavBar, Dialog, Divider,
    CapsuleTabs, Toast, Empty, Badge, Input, Button, Popup
} from 'antd-mobile';
import './index.css' // Premium styles
import { EditSOutline, CheckOutline, DownOutline } from 'antd-mobile-icons'
import EventInfo from '../../Utils/EventInfo';


import MvpDetail from './mvpDetail';
import Icon from '../../icon';
import LogoShow from '../../Home/logoShow';
import DinnerInfo from '../../Dinner/DinnerInfo';
import HistoryTitle from './historyTitle';
import LineupView from './LineupView';
import { useGameRouteId } from '../../features/match/hooks/useGameRouteId';
import { getTeamAverage } from '../../features/match/model/teamStats';
import { getDefaultMemberAvatar, getMatchMemberAvatar } from '../../features/match/model/memberAvatar';
import { useAuth } from '../../app/providers/AuthProvider';
import { useBodyStyleScope } from '../../shared/hooks/useBodyStyleScope';

export default function GameHistoryDetail() {
    useBodyStyleScope('style-scope--history-detail');
    const navigate = useNavigate()
    const { memberInfo, isAuthenticated, isGuest } = useAuth()
    const gameId = useGameRouteId('history');
    const [memberListInfo, setMemberListInfo] = useState([])

    const [gameDetail, setGameDetail] = useState("")
    const [gameEventInfo, setGameEventInfo] = useState([])
    const [mvpInfo, setMvpInfo] = useState("")
    const [mvpList, setMvpList] = useState([]);
    const [mvpDetailInfo, setMvpDetailInfo] = useState([])
    const [isPigeonVisible, setIsPigeonVisible] = useState(false);
    const [selectedPigeon, setSelectedPigeon] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');


    const redCaptian = memberListInfo?.find(item => item.id === gameDetail.redCaptainId)
    const greenCaptain = memberListInfo?.find(item => item.id === gameDetail.greenCaptainId)

    const formatPlayTime = (seconds) => {
        if (isNaN(seconds) || seconds === null || seconds === undefined) {
            return `0'`;
        } else {
            const minutes = Math.floor(seconds / 60);
            return `${minutes}'`;
        }
    };

    const getMvpDetailInfo = (memberId) => {
        setMvpDetailInfo([])
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.game_mvpDetail, {
            params: {
                gameId: gameId,
                memberId: memberId
            }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    setMvpDetailInfo(response.data.data)
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail',
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    content: error,
                    icon: 'fail',
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }


    const getUserListInfo = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.member_gameList, {
            params: {
                gameId: gameId
            }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    setMemberListInfo(response.data.data)
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail',
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    content: error,
                    icon: 'fail',
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameId])


    const defaultImage = (user) => getDefaultMemberAvatar(user, Icon)

    const getMemberImage = (user) => getMatchMemberAvatar(user, gameDetail, Icon)

    const isExternalMatch = [1, 2].includes(Number(gameDetail?.gameType ?? gameDetail?.game_type));
    const canEditMatchTitle = (() => {
        const finishTimeValue = gameDetail?.secondHalfEndTime || gameDetail?.endTime;
        if (!finishTimeValue || isGuest) return false;
        const finishTime = new Date(finishTimeValue);
        if (Number.isNaN(finishTime.getTime())) return false;
        const currentTime = new Date();
        const editEndTime = new Date(finishTime.getTime() + 24 * 60 * 60 * 1000);
        return currentTime > finishTime && currentTime <= editEndTime;
    })();

    const openMatchTitleEdit = () => {
        if (!canEditMatchTitle) return;
        let gameNameInput = gameDetail?.gameName || '';
        let reamarkInput = gameDetail?.gameRemark || '';
        Dialog.confirm({
            title: '修改比赛信息',
            className: 'match-title-edit-dialog',
            content: (
                <div className="match-title-edit-body">
                    <div className="match-title-edit-field">
                        <span>比赛名称</span>
                        <Input
                            placeholder='请输入比赛名称'
                            clearable
                            defaultValue={gameNameInput}
                            onChange={(value) => gameNameInput = value}
                        />
                    </div>
                    <div className="match-title-edit-field">
                        <span>比赛备注</span>
                        <Input
                            placeholder='请输入比赛备注'
                            clearable
                            defaultValue={reamarkInput}
                            onChange={(value) => reamarkInput = value}
                        />
                    </div>
                    <div className="match-title-edit-tip">比赛结束后 24 小时内可修改。</div>
                </div>
            ),
            onConfirm: () => {
                if (!gameNameInput && !reamarkInput) {
                    Toast.show({ icon: 'fail', content: '请输入比赛名称或备注' });
                    return Promise.reject();
                }
                Toast.show({
                    icon: 'loading',
                    content: '修改中...',
                    duration: 0,
                });
                const dataPost = {
                    gameId: gameDetail?.id,
                    memberId: memberInfo?.id,
                    gameName: gameNameInput || null,
                    gameRemark: reamarkInput || null
                }
                return axios.post(API_ROUTES.game_updateGameInfo, dataPost, {})
                    .then(function (response) {
                        if (response.data.code === 200) {
                            Toast.show({
                                content: '修改成功！',
                                icon: 'success',
                                afterClose: () => getGameDetail(),
                            })
                        } else {
                            Toast.show({
                                content: response.data.msg,
                                icon: 'fail',
                                afterClose: () => getGameDetail(),
                            })
                        }
                    })
                    .catch(function () {
                        Toast.show({
                            content: '修改失败,请重试!',
                            icon: 'fail'
                        })
                    });
            }
        })
    };

    const getMvpListInfo = useCallback((targetGameId) => {
        axios.get(API_ROUTES.game_mvpList, {
            params: { gameId: targetGameId }
        })
            .then(function (response) {
                const resultData = response.data.data;
                if (resultData) {
                    setMvpList(resultData);
                }
            })
            .catch(function () {
                Toast.show({ icon: 'fail', content: '获取MVP列表失败' });
            });
    }, [])

    const getGameDetail = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.game_info, {
            params: {
                id: gameId
            }
        })
            .then(function (response) {
                const resultData = response.data.data
                if (resultData) {
                    axios.get(API_ROUTES.game_gameMvp, {
                        params: {
                            memberId: memberInfo?.id,
                            gameId: resultData.id
                        }
                    }, null)
                        .then(function (response) {
                            if (response.data.data) {
                                setMvpInfo(response.data.data)
                            }
                            Toast.clear()
                        })
                        .catch(function (error) {
                            Toast.show({
                                icon: 'fail',
                                content: '查询失败，请联系管理员！'
                            })
                        })
                        .finally(() => {
                            Toast.clear()
                        });
                }
                getMvpListInfo(resultData.id);
                setGameDetail(resultData)
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameId, getMvpListInfo, memberInfo?.id])

    const getCurrentInfo = () => {
        if (gameDetail && Array.isArray(memberListInfo)) {
            const zhucai = memberListInfo?.filter(user => user?.gameType === 1);
            const biancai = memberListInfo?.filter(user => user?.gameType === 2);
            const varMember = memberListInfo?.filter(user => user?.gameType === 3);
            const guanzhong = memberListInfo?.filter(user => user?.gameType === 4);
            const birdPlayers = memberListInfo?.filter(user => user.gameType === 7);
            const leaveUser = memberListInfo?.filter(user => user.gameType === 5);
            const lazyUser = memberListInfo?.filter(user => (user.gameType === 6 || user.gameType === null) && user.tempMember === null);

            const renderMemberGridItem = (user, index) => (
                <Grid.Item key={user.id || index} onClick={() => navigate(`/members/${user.id}`)}>
                    <div className="member-grid-item">
                        <div className="member-grid-avatar-wrapper">
                            <img
                                src={defaultImage(user)}
                                className="member-grid-avatar"
                                alt={user.name}
                            />
                        </div>
                        <div className="member-grid-name">{user.name}</div>
                        {[1, 2, 3].includes(user.gameType) && (
                            <div className="member-grid-role">
                                {user.gameType === 1 ? "主裁" : user.gameType === 2 ? "边裁" : "VAR"}
                            </div>
                        )}
                    </div>
                </Grid.Item>
            );

            // Sub-component for categorized leave reasons with grid/list toggle
            const LeaveCategory = ({ reason, groupMembers, gIndex }) => {
                const [isExpanded, setIsExpanded] = useState(false);
                return (
                    <div key={reason} className={`leave-reason-group ${gIndex === 0 ? 'first' : ''}`}>
                        <div
                            className="leave-reason-header"
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            <div className="leave-reason-left">
                                <span className="leave-reason-text">{reason}</span>
                                <Badge content={groupMembers.length} color='#3b82f6' className="leave-reason-badge" />
                            </div>
                            <div className={`leave-category-chevron ${isExpanded ? 'rotated' : ''}`}>
                                <DownOutline fontSize={14} />
                            </div>
                        </div>

                        <div className="leave-category-content">
                            {isExpanded ? (
                                <div className="leave-items-list-detailed">
                                    {groupMembers.map((user, index) => (
                                        <div key={user.id || index} className="leave-item-row-detailed" onClick={() => navigate(`/members/${user.id}`)}>
                                            <div className="leave-item-avatar-wrapper">
                                                <img src={defaultImage(user)} className="leave-item-avatar-small" alt={user.name} />
                                            </div>
                                            <div className="leave-item-content">
                                                <div className="leave-item-name-row">
                                                    <span className="leave-item-name-bold">{user.name}</span>
                                                    <span className="leave-item-tag">详情</span>
                                                </div>
                                                <div className="leave-item-remark-text">{user.remark || '未填写具体原因'}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="leave-items-grid-compact">
                                    <Grid columns={5} gap={10}>
                                        {groupMembers.map((user, index) => (
                                            <Grid.Item key={user.id || index} onClick={() => navigate(`/members/${user.id}`)}>
                                                <div className="leave-grid-item-compact">
                                                    <img src={defaultImage(user)} className="leave-grid-avatar-compact" alt={user.name} />
                                                    <div className="leave-grid-name-compact">{user.name}</div>
                                                </div>
                                            </Grid.Item>
                                        ))}
                                    </Grid>
                                </div>
                            )}
                        </div>
                    </div>
                );
            };

            const renderMemberSection = (title, members) => {
                if (!members || members.length === 0) return null;
                return (
                    <div className="member-category-card">
                        <div className="member-header-container">
                            <div className="member-category-title" style={{ marginBottom: 0 }}>
                                {title} ({members.length})
                            </div>
                        </div>
                        <Grid columns={5} gap={12}>
                            {members.map((user, index) => renderMemberGridItem(user, index))}
                        </Grid>
                    </div>
                );
            };

            const renderLeaveSection = (title, members) => {
                if (!members || members.length === 0) return null;

                const keywords = ['工作', '家庭', '身体', '饭局', '出差', '其他'];
                const groups = {
                    '工作': [], '家庭': [], '身体': [], '饭局': [], '出差': [], '其他': []
                };

                members.forEach(user => {
                    const remark = user.remark || '';
                    const match = keywords.find(k => remark.startsWith(k));
                    if (match) {
                        groups[match].push(user);
                    } else {
                        groups['其他'].push(user);
                    }
                });

                return (
                    <div className="member-category-card">
                        <div className="member-header-container">
                            <div className="member-category-title">
                                {title} ({members.length})
                            </div>
                        </div>
                        <div className="leave-content-wrapper">
                            {Object.entries(groups).map(([reason, groupMembers], gIndex) => {
                                if (groupMembers.length === 0) return null;
                                return (
                                    <LeaveCategory
                                        key={reason}
                                        reason={reason}
                                        groupMembers={groupMembers}
                                        gIndex={gIndex}
                                    />
                                );
                            })}
                        </div>
                    </div>
                );
            };

            const refereeGroup = [...zhucai, ...biancai, ...varMember];
            const renderPigeonActionButton = () => {
                if (memberInfo?.admin !== 1) return null;
                return (
                    <div className="pigeon-bottom-action">
                        {/* 管理员入口单独放在所有人员列表底部，避免和某一个分类列表绑定。 */}
                        <Button
                            block
                            className="pigeon-bottom-action-btn"
                            onClick={() => {
                                setSearchTerm('');
                                setIsPigeonVisible(true);
                            }}
                        >
                            <EditSOutline fontSize={18} />
                            <span>选择鸽子人员</span>
                        </Button>
                    </div>
                );
            };

            return (
                <div style={{ padding: '0 4px' }}>
                    {renderMemberSection('裁判组', refereeGroup)}
                    {renderMemberSection('观众', guanzhong)}
                    {renderMemberSection('鸽子人员', birdPlayers)}
                    {renderLeaveSection('请假人员', leaveUser)}
                    {renderMemberSection('懒人', lazyUser)}
                    {refereeGroup.length === 0 && guanzhong.length === 0 && birdPlayers.length === 0 && leaveUser.length === 0 && lazyUser.length === 0 && (
                        <Empty description="暂无人员信息" />
                    )}
                    {renderPigeonActionButton()}
                </div>
            );
        }
        return <Empty description="加载中..." />;
    };

    const getModelContent = (type) => {
        switch (type) {
            case 1:
                return '1-3-2-2'
            case 2:
                return '1-3-3-1'
            case 3:
                return '1-4-4-2'
            case 4:
                return '1-5-3-2'
            case 5:
                return '1-3-5-2'
            case 6:
                return '1-5-4-1'
            case 7:
                return '1-4-5-1'
            case 8:
                return '1-4-4-3'
            case 9:
                return '1-5-4-2'
            case 10:
                return '1-4-5-2'
            case 11:
                return '1-5-5-1'
            case 12:
                return '1-5-3-3'
            default:
                return ''
        }
    }
    const getGameEventInfo = useCallback(() => {
        axios.get(API_ROUTES.game_eventInfo, {
            params: {
                gameId: gameId
            }
        })
            .then(function (response) {
                setGameEventInfo(response.data.data)
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {

            });
    }, [gameId])

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login')
            return
        }
        if (!gameId) return

        Toast.show({ icon: 'loading', content: '加载中…', duration: 0 })
        getGameDetail()
        getGameEventInfo()
        getUserListInfo()
    }, [gameId, getGameDetail, getGameEventInfo, getUserListInfo, isAuthenticated, navigate])



    const getUserSubsitituteInfo = (team) => {
        if (gameDetail && Array.isArray(memberListInfo)) {
            const userPosition = team === 1 ? gameDetail?.greenModelConfirm : gameDetail?.redModelConfirm;
            const userPositionJson = userPosition ? JSON.parse(userPosition) : null;

            const currentUsers = memberListInfo?.filter(item => {
                if (item.gameType !== 0) {
                    return false;
                }
                if (userPositionJson === null) {
                    return item.gameTeam === team
                } else {
                    const matchingItem = userPositionJson?.find(others => others.id === item.id)
                    return !matchingItem && item.gameTeam === team
                }
            })

            const currentTeam = currentUsers.sort((a, b) => {

                // 判断 a 和 b 是否为队长
                const isCaptainA = a.id === redCaptian?.id || a.id === greenCaptain?.id;
                const isCaptainB = b.id === redCaptian?.id || b.id === greenCaptain?.id;

                // 先比较队长情况
                if (isCaptainA && !isCaptainB) return -1;
                if (!isCaptainA && isCaptainB) return 1;

                // 判断 a 和 b 是否为副队长
                const isSubCaptainA = a.subCaptain;
                const isSubCaptainB = b.subCaptain;

                // 如果 a 是队长，b 是副队长，a 排在前面
                if (isCaptainA && isSubCaptainB) return -1;
                // 如果 a 是副队长，b 是队长，b 排在前面
                if (isSubCaptainA && isCaptainB) return 1;

                // 如果 a 是副队长，b 不是副队长，a 排在前面
                if (isSubCaptainA && !isSubCaptainB) return -1;
                // 如果 a 不是副队长，b 是副队长，b 排在前面
                if (!isSubCaptainA && isSubCaptainB) return 1;

                // 如果都不是队长和副队长，按 gameRole 排序
                return a.gameRole - b.gameRole;
            });


            return (
                currentTeam?.map((user) => {
                    const teamColor = user.gameTeam === 1 ? gameDetail?.greenColor : gameDetail?.redColor;
                    return (
                        <div
                            key={user.id}
                            className="sub-player-card"
                            style={{
                                backgroundColor: teamColor ? `${teamColor}1A` : 'rgba(22, 93, 255, 0.05)',
                                border: teamColor ? `1px solid ${teamColor}` : '1px solid rgba(22, 93, 255, 0.1)',
                                boxShadow: teamColor ? `0 4px 16px ${teamColor}15` : 'none'
                            }}
                            onClick={() => {
                                if (memberInfo?.temp === '1') {
                                    navigate(`/members/${user?.id}`);
                                } else {
                                    Dialog.confirm({
                                        content: '是否投票' + user.name + '为MVP',
                                        onConfirm: () => {
                                            const formData = new FormData();
                                            formData.append('memberId', memberInfo.id);
                                            formData.append('likeMemberId', user?.id);
                                            formData.append('gameId', gameDetail.id)

                                            axios.post(API_ROUTES.game_setMvp, formData, {
                                                headers: {
                                                    'Content-Type': 'multipart/form-data'
                                                }
                                            }).then((res) => {
                                                if (res.data.code === 200) {
                                                    Toast.show({
                                                        icon: 'success',
                                                        content: '投票成功!',
                                                    })
                                                    getGameDetail()
                                                } else if (res.data.code === 500) {
                                                    Toast.show({
                                                        icon: 'fail',
                                                        content: res.data.msg
                                                    })
                                                }
                                            })
                                        },
                                    })
                                }
                            }}
                        >
                            {/* ─── Goal overlay: top-right of card ─── */}
                            {(user?.goalFlag > 0 || user?.penaltyFlag > 0 || user?.ownGoalFlag > 0 || user?.penaltyNotFlag > 0) && (
                                <div className="sub-card-goal-overlay">
                                    {user?.goalFlag > 0 && (
                                        <span className="sub-goal-pill">
                                            <img src={Icon.GOAL} alt="goal" className="pc-goal-icon" />
                                            {user.goalFlag > 1 && <b>×{user.goalFlag}</b>}
                                        </span>
                                    )}
                                    {user?.penaltyFlag > 0 && (
                                        <span className="sub-goal-pill">
                                            <img src={Icon.PENALTY_KICK} alt="penalty" className="pc-goal-icon" />
                                            {user.penaltyFlag > 1 && <b>×{user.penaltyFlag}</b>}
                                        </span>
                                    )}
                                    {user?.ownGoalFlag > 0 && (
                                        <span className="sub-goal-pill sub-goal-og">
                                            <img src={Icon.OWN_GOAL} alt="og" className="pc-goal-icon" />
                                        </span>
                                    )}
                                    {user?.penaltyNotFlag > 0 && (
                                        <span className="sub-goal-pill sub-goal-miss">
                                            <img src={Icon.PENALTY_NOT_SCORED} alt="miss" className="pc-goal-icon" />
                                        </span>
                                    )}
                                </div>
                            )}
                            {/* ─── Avatar Structure ─── */}
                            <div className="sub-avatar-wrap">
                                {(user.id === redCaptian?.id || user.id === greenCaptain?.id) && (
                                    <img src={Icon.CAPTAIN} alt="captain" className="pc-corner-badge pc-corner-tl" />
                                )}
                                {!(user.id === redCaptian?.id || user.id === greenCaptain?.id) && user?.subCaptain === 1 && (
                                    <img src={Icon.SUB_CAPTAIN} alt="sub captain" className="pc-corner-badge pc-corner-tl" />
                                )}
                                <div
                                    className="sub-avatar"
                                    style={{
                                        border: teamColor ? `3px solid ${teamColor}` : '3px solid #CDCDCD'
                                    }}
                                >
                                    <img
                                        src={getMemberImage(user)}
                                        className="sub-avatar-img"
                                        alt={user.name}
                                    />
                                </div>
                                {/* ─── Play Time (GameHistoryDetail specific) ─── */}
                                <div className="sub-avatar-time">
                                    {formatPlayTime(user?.playTime)}
                                </div>
                            </div>
                            {/* ─── Name + role + status row ─── */}
                            <div className="sub-info">
                                <div className="sub-name">
                                    {user?.injured === 1 && (
                                        <img src={Icon.SHOUSHANG} alt="injured" className="pc-name-injury-icon" />
                                    )}
                                    {user.name}
                                </div>
                                <div className="sub-role">{user.gameRoleName}</div>
                                {/* Sub arrow + cards — separate display */}
                                {(user?.upDown != null || user?.redCardFlag > 0 || user?.yellowCardFlag > 0) && (
                                    <div className="sub-status-row">
                                        {user?.upDown === 1 && (
                                            <span className="sub-updown sub-updown-in">
                                                <img src={Icon.UP_ICON} alt="up" style={{ width: '14px', height: '14px' }} />
                                                上场
                                            </span>
                                        )}
                                        {user?.upDown === 0 && (
                                            <span className="sub-updown sub-updown-out">
                                                <img src={Icon.DOWN_ICON} alt="down" style={{ width: '14px', height: '14px' }} />
                                                下场
                                            </span>
                                        )}
                                        {user?.yellowCardFlag > 0 && Array(user.yellowCardFlag).fill().map((_, i) => (
                                            <span key={`yc-${user.id}-${i}`} className="pc-card pc-card-yellow" />
                                        ))}
                                        {user?.redCardFlag > 0 && Array(user.redCardFlag).fill().map((_, i) => (
                                            <span key={`rc-${user.id}-${i}`} className="pc-card pc-card-red" />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })
            );
        } else {
            return null;
        }

    }

    const avgAge = (team) => getTeamAverage(memberListInfo, team, 'age')

    const avgGrade = (team) => getTeamAverage(memberListInfo, team, 'integral')

    const handlePlayerClick = (player) => {
        if (memberInfo?.temp === '1') {
            navigate(`/members/${player?.id}`);
        } else {
            Dialog.confirm({
                title: 'MVP投票',
                content: '是否投票 ' + player.name + ' 为MVP?',
                onConfirm: () => {
                    Toast.show({ icon: 'loading', duration: 0 });
                    const formData = new FormData();
                    formData.append('memberId', memberInfo.id);
                    formData.append('likeMemberId', player?.id);
                    formData.append('gameId', gameDetail.id)

                    axios.post(API_ROUTES.game_setMvp, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((res) => {
                        if (res.data.code === 200) {
                            Toast.show({ icon: 'success', content: '投票成功!' })
                            getGameDetail()
                        } else if (res.data.code === 500) {
                            Toast.show({ icon: 'fail', content: res.data.msg })
                        }
                    }).finally(() => Toast.clear())
                },
            })
        }
    }

    return (
        <div className="game-history-detail-container has-unified-nav">
            <NavBar
                back=''
                className='unified-navbar fixed'
                onBack={() => window.history.back()}
            >
                比赛详情
            </NavBar>

            {/* 比赛结束详情头部：编辑按钮仅在结束后 24 小时内展示，避免过期后误触。 */}
            <div className="match-detail-hero">
                <div className="match-hero-title-row">
                    <h1 className="match-hero-title">{gameDetail?.gameName || '比赛详情'}</h1>
                    {canEditMatchTitle && (
                        <button type="button" className="match-title-edit-btn" onClick={openMatchTitleEdit} aria-label="编辑比赛信息">
                            <EditSOutline fontSize={14} />
                        </button>
                    )}
                </div>
                <div className="match-hero-subtitle">
                    {gameDetail?.gameRemark || '暂无备注信息'}
                </div>
                <div className="match-hero-meta-row">
                    <span>{gameDetail?.startDate}</span>
                    <i />
                    <span>{gameDetail?.week}</span>
                    {gameDetail?.type && (
                        <>
                            <i />
                            <span>{gameDetail.type}</span>
                        </>
                    )}
                </div>
                <div className="match-hero-address">
                    <span>📍</span>
                    <strong>{gameDetail?.address || '暂无比赛地址'}</strong>
                </div>
            </div>
            {/* <Map center={{ lng: gameDetail.lng, lat: gameDetail.lat }} zoom="15" style={{ position: 'relative', height: '200px' }}>
                        <Marker position={{ lng: gameDetail.lng, lat: gameDetail.lat }} />
                        <NavigationControl />
                    </Map> */}
            <div style={{ padding: '0 12px', marginBottom: '24px' }}>
                <HistoryTitle gameDetail={gameDetail} getGameDetail={getGameDetail} />
            </div>

            {/* 访客仅浏览比赛公开数据，隐藏相册入口避免进入需要身份操作的影像模块。 */}
            {!isGuest && (
                <div className="match-album-panel">
                    <div className="match-album-copy">
                        <div className="match-album-kicker">MATCH ALBUM</div>
                        <div className="match-album-title">本场比赛影像</div>
                        <div className="match-album-desc">查看和上传这场比赛的照片、视频，也可以继续绑定到具体赛况事件。</div>
                    </div>
                    <div className="match-album-buttons">
                        <button
                            type="button"
                            className="match-album-btn match-album-btn--light"
                            onClick={() => navigate('/album', { state: { gameId: gameDetail?.id || gameId, gameName: gameDetail?.gameName } })}
                        >
                            查看影像
                        </button>
                        <button
                            type="button"
                            className="match-album-btn match-album-btn--primary"
                            onClick={() => navigate('/albumUpload', { state: { gameId: gameDetail?.id || gameId, gameName: gameDetail?.gameName } })}
                        >
                            上传影像
                        </button>
                    </div>
                </div>
            )}


            <CapsuleTabs defaultActiveKey={"1"} className="premium-segment-tabs">
                <CapsuleTabs.Tab title='阵容' key='1'>
                    {mvpInfo?.likeMemberId ?
                        <MvpDetail
                            mvpInfo={mvpList}
                            mvpDetail={mvpDetailInfo}
                            getMvpDetailInfo={getMvpDetailInfo}
                            memberList={memberListInfo}
                        />
                        :
                        <div style={{
                            margin: '12px 16px',
                            padding: '12px 16px',
                            background: 'rgba(59, 130, 246, 0.1)',
                            border: '1px solid rgba(59, 130, 246, 0.3)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            backdropFilter: 'blur(12px)',
                            WebkitBackdropFilter: 'blur(12px)',
                            boxShadow: '0 4px 20px rgba(22, 93, 255, 0.1), inset 0 0 0 1px rgba(22, 93, 255, 0.05)'
                        }}>
                            <div style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)'
                            }}>
                                <span style={{ fontSize: '18px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}>👑</span>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '15px',
                                    fontWeight: '800',
                                    color: '#165DFF',
                                    marginBottom: '4px',
                                    textShadow: '0 1px 2px rgba(22, 93, 255, 0.1)',
                                    letterSpacing: '0.5px'
                                }}>
                                    MVP 评选
                                </div>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#475569',
                                    lineHeight: '1.4'
                                }}>
                                    请在下方阵容图中<span style={{ color: '#1e293b', fontWeight: 'bold' }}>点击球员头像</span>进行投票
                                </div>
                            </div>
                            {/* Decorative glowing orb in background */}
                            <div style={{
                                position: 'absolute',
                                right: '-10px',
                                top: '-10px',
                                width: '60px',
                                height: '60px',
                                background: 'radial-gradient(circle, rgba(59,130,246,0.3) 0%, rgba(59,130,246,0) 70%)',
                                borderRadius: '50%',
                                pointerEvents: 'none'
                            }} />
                        </div>
                    }


                    <div className={`field-container history-lineup-field ${isExternalMatch ? 'history-lineup-field--external' : ''}`} style={{
                        position: 'relative',
                        width: '100%',
                        minHeight: '800px',
                        marginTop: '10px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                        // 足球场背景统一从 icon.js 获取，和实时赛况保持同一张图
                        '--football-field-bg': `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`
                    }}>
                        <div className="history-lineup-pitch">
                            {/* Team 1 (Green) */}
                            <div className="history-lineup-half history-lineup-half--top">
                                <div className="pitch-info-bar pitch-info-bar-top">
                                    <div className="pitch-tag-group">
                                        <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                    </div>
                                    <div className="pitch-tag-group">
                                        <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                    </div>
                                </div>
                                <LineupView
                                    gameDetail={gameDetail}
                                    team={1}
                                    memberListInfo={memberListInfo}
                                    onPlayerClick={handlePlayerClick}
                                />
                            </div>

                            {/* Team 2 (Red) */}
                            <div className="history-lineup-half history-lineup-half--bottom">
                                <LineupView
                                    gameDetail={gameDetail}
                                    team={2}
                                    memberListInfo={memberListInfo}
                                    onPlayerClick={handlePlayerClick}
                                />
                                <div className="pitch-info-bar pitch-info-bar-bottom">
                                    <div className="pitch-tag-group">
                                        <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                    </div>
                                    <div className="pitch-tag-group">
                                        <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider style={{
                        color: '#86909C',
                        borderColor: 'rgba(0, 0, 0, 0.08)',
                        fontSize: '13px',
                        marginTop: '24px',
                        marginBottom: '16px'
                    }}>替补阵容</Divider>
                    {/* SubTeamList Removed - Data moved to Header */}
                    <Grid columns={2} gap={12}>
                        <Grid.Item>
                            <div style={{
                                textAlign: 'center',
                                padding: '8px',
                                color: '#86909C',
                                fontSize: '13px',
                                fontWeight: '600',
                                marginBottom: '8px'
                            }}>
                                队长: {greenCaptain?.name}
                            </div>
                            {getUserSubsitituteInfo(1)}
                        </Grid.Item>
                        <Grid.Item>
                            <div style={{
                                textAlign: 'center',
                                padding: '8px',
                                color: '#86909C',
                                fontSize: '13px',
                                fontWeight: '600',
                                marginBottom: '8px'
                            }}>
                                队长: {redCaptian?.name}
                            </div>
                            {getUserSubsitituteInfo(2)}
                        </Grid.Item>
                    </Grid>

                    {gameDetail.gameType !== 4 &&
                        getCurrentInfo()
                    }

                </CapsuleTabs.Tab>
                <CapsuleTabs.Tab title='赛况' key='2'>
                    <Card style={{ backgroundColor: 'transparent', border: 'none', padding: 0 }}>
                        <EventInfo
                            eventInfo={gameEventInfo}
                            gameInfo={gameDetail}
                            getGameDetail={getGameDetail}
                            memberListInfo={memberListInfo}
                            getEventInfo={getGameEventInfo}
                        />
                        <LogoShow />
                    </Card>
                </CapsuleTabs.Tab>
                {/* 访客不展示聚餐详情入口。 */}
                {!isGuest && (
                    <CapsuleTabs.Tab title='聚餐' key='3'>
                        <div className="dinner-info-wrapper">
                            <DinnerInfo gameDetail={gameDetail} memberListInfo={memberListInfo} />
                        </div>
                    </CapsuleTabs.Tab>
                )}
            </CapsuleTabs>


            <Popup
                visible={isPigeonVisible}
                onMaskClick={() => setIsPigeonVisible(false)}
                onClose={() => setIsPigeonVisible(false)}
                className="pigeon-popup"
                bodyStyle={{ borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}
            >
                <div className="pigeon-popup-header">
                    <div className="pigeon-popup-title">选择鸽子人员</div>
                    <div className="pigeon-popup-close" onClick={() => setIsPigeonVisible(false)}>取消</div>
                </div>

                <div className="pigeon-search-container">
                    <input
                        className="pigeon-search-input"
                        placeholder="搜索成员姓名..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="pigeon-popup-content" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <div className="pigeon-premium-grid">
                        {memberListInfo
                            ?.filter(item => [0, 1, 2, 3, 4].includes(item.gameType))
                            ?.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()))
                            ?.map(item => (
                                <div
                                    key={item.id}
                                    className={`pigeon-premium-card ${selectedPigeon === item.id ? 'pigeon-premium-card-selected' : ''}`}
                                    onClick={() => setSelectedPigeon(item.id)}
                                >
                                    <div className="pigeon-premium-avatar-wrapper">
                                        <img
                                            src={defaultImage(item)}
                                            className="pigeon-premium-avatar"
                                            alt=""
                                        />
                                        {selectedPigeon === item.id && (
                                            <div className="pigeon-selected-indicator">
                                                <CheckOutline color="#fff" fontSize={10} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="pigeon-premium-name">{item.name}</div>
                                </div>
                            ))}
                    </div>
                    {memberListInfo?.filter(item => [0, 1, 2, 3, 4].includes(item.gameType) && item.name.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 && (
                        <div style={{ padding: '40px 0' }}>
                            <Empty description="未找到匹配成员" />
                        </div>
                    )}
                </div>

                {selectedPigeon && (
                    <div style={{ padding: '0 20px 20px 20px' }}>
                        <Button
                            block
                            color="primary"
                            style={{ borderRadius: '12px', height: '48px', fontWeight: 'bold' }}
                            onClick={() => {
                                const player = memberListInfo.find(u => u.id === selectedPigeon);
                                Dialog.confirm({
                                    content: `确认将队员 ${player?.name} 设为"鸽子"吗？`,
                                    onConfirm: () => {
                                        Toast.show({ icon: 'loading', duration: 0 });
                                        const formData = new FormData();
                                        formData.append('memberId', selectedPigeon);
                                        formData.append('position', 7);
                                        formData.append('gameId', gameDetail.id);
                                        axios.post(API_ROUTES.game_update_bird, formData)
                                            .then(res => {
                                                if (res.data.code === 200) {
                                                    Toast.show({ icon: 'success', content: '更新成功' });
                                                    getGameDetail();
                                                    setIsPigeonVisible(false);
                                                    setSelectedPigeon(null);
                                                } else {
                                                    Toast.show({ icon: 'fail', content: res.data.msg });
                                                }
                                            })
                                            .catch(() => Toast.show({ icon: 'fail', content: '操作失败' }));
                                    }
                                });
                            }}
                        >
                            确认选择
                        </Button>
                    </div>
                )}
            </Popup>
        </div>
    )
}
